module.exports = {
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("./1.png").default,
        },
        {
            "time": 1000,
            "image": require("./2.png").default,
        },
        {
            "time": 1100,
            "image": require("./3.png").default,
        },
        {
            "time": 1200,
            "image": require("./4.png").default,
        },
        {
            "time": 1300,
            "image": require("./5.png").default,
        },
        {
            "time": 1400,
            "image": require("./1.png").default,
        },
        {
            "time": 1500,
            "image": require("./2.png").default,
        },
        {
            "time": 1600,
            "image": require("./3.png").default,
        },
        {
            "time": 1700,
            "image": require("./4.png").default,
        },
        {
            "time": 1800,
            "image": require("./5.png").default,
        },
        {
            "time": 1900,
            "image": require("./1.png").default,
        },
    ]
}
